import React from 'react';
import UsernameInput from '../../components/UsernameInput';
import { validateEmail as vm } from '../../core/core';
import styles from './InvitationControl.module.scss';

interface Props {
  onEmailChange: (value: string) => void;
  label?: string;
  isInviteSuppression: boolean;
  [k: string]: string | unknown | undefined;
}

const InvitationControl = (props: Props) => {
  const { label, isInviteSuppression, onEmailChange, ...rest } = props;

  const validateEmail = (value: string) => {
    if (!value) {
      return '';
    }
    if (!vm(value)) {
      return 'Must be in the correct form, e.g. joe@domain.com';
    }
    return '';
  };

  const handleOnChange = (value: string) => {
    return value;
  };

  const handleOutOfFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const error = validateEmail(value);
    if (error === '' && onEmailChange) {
      onEmailChange(value);
    }
  };

  if (isInviteSuppression) {
    return (
      <UsernameInput
        className={styles.InvitationControl}
        label={label}
        name='parentEmail'
        type='text'
        placeholder='Enter parent email'
        value='Invitation sent!'
        disabled
        {...rest}
      />
    );
  }
  return (
    <UsernameInput
      className={styles.InvitationControl}
      label={label}
      name='parentEmail'
      type='text'
      placeholder='Enter parent email'
      validate={validateEmail}
      onChange={handleOnChange}
      onBlur={handleOutOfFocus}
      {...rest}
    />
  );
};

export default InvitationControl;
